import { AxiosInstance } from "axios";
import { makeFormData } from "../components/utils/formData";
import { BaseHTTP } from "./base.http";


export class ConversationApi {

  private http !: AxiosInstance

  constructor() {
    this.http = BaseHTTP.getInstance().http
  }

  async getConversations() {
    const conversationsResponse = await this.http.get('v1/conversations')

    return conversationsResponse.data
  }

  async createConversation(firstMessage: string, files: File[]) {
    const selectedBusiness = localStorage.getItem('selectedBusiness')
    const companyId = selectedBusiness ? JSON.parse(selectedBusiness).id : null
    const newConversationData = makeFormData({ firstMessage, files, companyId })
    const conversationResponse = await this.http.post(
      'v1/conversations',
      newConversationData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    )
    
    return conversationResponse.data
  }

  async updateConversation(conversationId: string, conversation: any) {
    const conversationResponse = await this.http.put(
      `v1/conversations/${conversationId}`,
      conversation
    )

    return conversationResponse.data
  }

  async deleteConversation(conversationId: string) {
    const deleteResponse = await this.http.delete(`v1/conversations/${conversationId}`);

    return deleteResponse.data;
  }

  async getAgentResponse(conversationId: string) {
    const response = await this.http.get(`v1/conversations/agent-response?conversationId=${conversationId}`)

    return response.data
  }
}

export default new ConversationApi()
